// Project API service 
import apiClient from './api';

export default {
  /**
   * Get all projects with optional filtering
   * @param {Object} params - Query parameters for filtering
   * @returns {Promise} - Axios promise
   */
  getProjects(params = {}) {
    return apiClient.get('/projects/', { params });
  },
  
  /**
   * Get a specific project by ID
   * @param {Number|String} id - Project ID
   * @returns {Promise} - Axios promise
   */
  getProject(id) {
    return apiClient.get(`/projects/${id}/`);
  },
  
  /**
   * Get featured projects
   * @returns {Promise} - Axios promise
   */
  getFeaturedProjects() {
    return apiClient.get('/projects/', { params: { is_featured: true } });
  },
  
  /**
   * Get related projects for a specific project
   * @param {Number|String} id - Project ID
   * @returns {Promise} - Axios promise
   */
  getRelatedProjects(id) {
    return apiClient.get(`/projects/${id}/related/`);
  },
  
  /**
   * Filter projects by various criteria
   * @param {Object} filters - Object containing filter criteria
   * @returns {Promise} - Axios promise
   * 
   * Possible filters:
   * - project_type
   * - client_type
   * - year
   * - location
   * - service_area
   */
  filterProjects(filters = {}) {
    return apiClient.get('/projects/', { params: filters });
  },
  
  /**
   * Search projects by title or description
   * @param {String} query - Search query
   * @returns {Promise} - Axios promise
   */
  searchProjects(query) {
    return apiClient.get('/projects/', { params: { search: query } });
  },
  
  /**
   * Get project media items (images, videos)
   * @param {Number|String} id - Project ID
   * @returns {Promise} - Axios promise
   */
  getProjectMedia(id) {
    return apiClient.get(`/projects/${id}/media/`);
  }
}; 